import ComingSoonPage from "../ComingSoon";

const PeerGroupDashboard = () => {
  return (
    <ComingSoonPage title={"Peer Group Dashboard"} />
  );
};

export default PeerGroupDashboard;
